module.exports = __webpack_public_path__ + "img/logo.ccf7e1b8.svg";